import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PaymentProcessTokenRequest,
  PaymentRequest,
  PaymentResponse,
  PaymentTokenRequest,
  PaymentTokenResponse,
} from '@fsp-app/discovery-flights/features/landing-page/src/lib/models/payment.models';
import { DiscoveryFlight } from '@fsp-lib/discovery-flights';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private apiUrl = `${environment.apiUrl}/payments`;
  private paymentTokenUrl = `${environment.apiUrl}/payments/paymentTokens`;
  private processTokenUrl = `${environment.apiUrl}/payments/processToken`;

  constructor(private http: HttpClient) {}

  processPayment(paymentRequest: PaymentRequest): Observable<PaymentResponse> {
    return this.http.post<PaymentResponse>(this.apiUrl, paymentRequest);
  }

  postPaymentToken(
    payload: PaymentTokenRequest,
  ): Observable<PaymentTokenResponse> {
    return this.http.post<PaymentTokenResponse>(this.paymentTokenUrl, payload);
  }

  processPaymentToken(
    payload: PaymentProcessTokenRequest,
  ): Observable<PaymentResponse> {
    return this.http.post<PaymentResponse>(this.processTokenUrl, payload);
  }

  getFlightProductDetails(operatorId: number | string, lineItemGuid: string) {
    const url = `${environment.apiUrl}/operators/${operatorId}/products/${lineItemGuid}`;
    return this.http.get<DiscoveryFlight>(url);
  }
}
